import React from 'react';
import { Input } from 'antd';
import { UserOutlined, PhoneOutlined } from '@ant-design/icons';

interface TakeOutCustomerStripProps {
  name: string;
  phone: string;
  onNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  /** Edit mode: customer identity is fixed */
  disabled?: boolean;
}

/**
 * TakeOut customer: one compact row (name + phone) instead of a full-width
 * "Datos del Cliente" card pushing the menu down.
 */
const TakeOutCustomerStrip: React.FC<TakeOutCustomerStripProps> = ({
  name,
  phone,
  onNameChange,
  onPhoneChange,
  disabled = false,
}) => (
  <div className="ot-customer">
    <Input
      className="ot-field ot-field--name"
      prefix={<UserOutlined />}
      placeholder="Nombre del cliente *"
      value={name}
      onChange={(e) => onNameChange(e.target.value)}
      disabled={disabled}
    />
    <Input
      className="ot-field ot-field--phone"
      prefix={<PhoneOutlined />}
      placeholder="Teléfono (opcional)"
      value={phone}
      onChange={(e) => onPhoneChange(e.target.value)}
      disabled={disabled}
    />
  </div>
);

export default TakeOutCustomerStrip;
